const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export const getEffectiveInputValue = (stateValue, inputElement) =>
  String(inputElement?.value ?? stateValue ?? "").trim();

export const validateReportRecipient = ({ name, email }) => {
  const normalizedName = String(name || "").trim();
  const normalizedEmail = String(email || "").trim().toLowerCase();

  if (normalizedName.length < 2) {
    return { valid: false, message: "Please enter your name." };
  }
  if (!EMAIL_PATTERN.test(normalizedEmail)) {
    return { valid: false, message: "Please enter a valid email address." };
  }

  return { valid: true, name: normalizedName, email: normalizedEmail };
};

export const safeStorageGet = (storage, key, fallback = "") => {
  try {
    return storage?.getItem(key) ?? fallback;
  } catch (error) {
    return fallback;
  }
};

export const safeStorageSet = (storage, key, value) => {
  try {
    storage?.setItem(key, value);
    return true;
  } catch (error) {
    return false;
  }
};

